<template>
  <card :padding="false" class="card-container" :class="{ expanded }">
    <div class="d-lg-flex activity-feed-container">
      <div class="col-lg-7 col-12 px-0">
        <div class="d-flex align-items-center activity-heading">
          <collapse-caret class="mr-2" :expanded="expanded" @click="expanded = !expanded" />
          <div class="flex-grow-1 d-flex justify-content-between align-items-center pr-4">
            <div class="text-large bolder">Updates for you</div>
            <activity-type-filter
              class="activity-filter"
              :selected="eventType"
              @change="onEventTypeChange"
            />
          </div>
        </div>
        <b-collapse v-model="expanded">
          <activity-feed
            :filter-details="filterDetails"
            class="activity-feed"
            :org-id="orgId"
            :sub-org-id="subOrgId"
          />
        </b-collapse>
      </div>
      <hr class="d-lg-none d-block my-4" v-if="expanded" />
      <div class="col-lg-5 col-12 pr-0 pl-lg-4" v-if="expanded">
        <div class="text-large bolder mb-3 pb-2">Your recent visits</div>
        <recent-pages
          :filter-details="filterDetails"
          class="recent-pages"
          :side-gutter="0"
          :org-id="orgId"
          @click.native="onRecentClick"
        >
          <div slot="emptyState" class="empty-state wrap-hyphenate">
            You haven't seen much of your team's work in North yet - Why not start with your
            <router-link class="text-primary" :to="orgPageLocation"
              ><u>organization’s goals</u></router-link
            >?
          </div>
        </recent-pages>
      </div>
    </div>
  </card>
</template>

<script>
import { trackAnalyticsEvent, trackEvent } from '@/analytics'
import ActivityTypeFilter from '@/components/activity/ActivityTypeFilter'
import { ACTIVITY_TYPE_ANALYTICS_NAME } from '@/constants/activity'
import { EVENT_ACTION, EVENT_CATEGORY, SOURCE } from '@/constants/analytics'
import { getTeamPageRouteConfig } from '@/utils/navigationConfigs'
import { BCollapse } from 'bootstrap-vue'
import ActivityFeed from '@/components/activity/ActivityFeed'
import Card from '@/components/Card'
import CollapseCaret from '@/components/CollapseCaret'
import RecentPages from '@/components/RecentPages'
import { goalsTabIds } from '@/constants/goals'

export default {
  name: 'ActivityCard',
  props: ['orgId', 'subOrgId'],
  components: {
    ActivityFeed,
    Card,
    RecentPages,
    CollapseCaret,
    BCollapse,
    ActivityTypeFilter
  },
  data() {
    return {
      orgPageLocation: getTeamPageRouteConfig({
        orgId: this.orgId,
        entity: goalsTabIds.goals,
        teamId: this.subOrgId
      }),
      expanded: true,
      eventType: null,
      filterDetails: null
    }
  },
  methods: {
    onRecentClick() {
      trackAnalyticsEvent(EVENT_CATEGORY.ACTIVITY, EVENT_ACTION.CLICK_RECENT, {
        CTA: SOURCE.YOUR_WORK
      })
    },
    onEventTypeChange(eventType) {
      this.eventType = eventType.id
      this.filterDetails = {
        filterName: eventType.filterName,
        filterValue: eventType.filterValue
      }
      trackEvent(
        EVENT_CATEGORY.PREFERENCE,
        EVENT_ACTION.ACTIVITY_FILTER_YOUR_WORK,
        ACTIVITY_TYPE_ANALYTICS_NAME[eventType.id]
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.activity-feed,
.recent-pages {
  @include scrollbarWidth($scrollSecondary);
  overflow-y: auto;
  max-height: 430px;
}

.recent-pages {
  word-break: break-all;
  hyphens: auto;
  padding-right: 20px;
  margin-right: -15px;
}

.empty-state {
  margin: 25px auto;
  text-align: center;
}

.activity-heading {
  margin-left: -15px;
  margin-bottom: 0;
}
.activity-filter {
  display: none;
}
.expanded {
  .activity-heading {
    margin-bottom: 24px;
  }
  .activity-filter {
    display: flex;
  }
}

.activity-feed {
  padding-right: 24px;
}

.card-container {
  padding: 20px 25px;
}

@include media-breakpoint-down(md) {
  .activity-feed {
    padding-right: 0;
  }
  .card-container {
    padding: 15px 20px;
  }
  .activity-feed {
    overflow-y: initial;
    max-height: initial;
  }
  .recent-pages {
    padding-right: 0;
    margin-right: 0;
  }
}
</style>
